import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/no-data.png'


const _withScopeId = n => (_pushScopeId("data-v-5c302abc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "packageBug-container sbom-container" }
const _hoisted_2 = { class: "query-list" }
const _hoisted_3 = { class: "query-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "漏洞编号：", -1))
const _hoisted_5 = { class: "query-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "漏洞级别：", -1))
const _hoisted_7 = { class: "sbom-table" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-data" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "暂无相关内容")
], -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { class: "sbom-pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_input, {
          modelValue: _ctx.vulId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vulId) = $event)),
          style: {"width":"250px"},
          placeholder: "输入漏洞编号,Enter键回车搜索",
          "prefix-icon": _ctx.Search,
          onKeyup: _withKeys(_ctx.search, ["enter"])
        }, null, 8, ["modelValue", "prefix-icon", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_el_select, {
          modelValue: _ctx.vulSeverity,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vulSeverity) = $event)),
          clearable: "",
          placeholder: "请选择",
          onChange: _ctx.search
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vulSeverityList, (item, itemIndex) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: itemIndex,
                label: item.label,
                value: item.prop
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        border: "",
        "highlight-current-row": "",
        "scrollbar-always-on": ""
      }, {
        empty: _withCtx(() => [
          _hoisted_8
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, colIndex) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: colIndex,
              label: col.label,
              width: col.width,
              minWidth: col.minWidth,
              "show-overflow-tooltip": col.showTooltip
            }, {
              default: _withCtx((scope) => [
                (col.type === 'link')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.openEchart(scope.row)),
                      class: "link"
                    }, _toDisplayString(scope.row[col.prop] || '--'), 9, _hoisted_9))
                  : (col.hasBgcolor)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(['bgColor', _ctx.formatCellColor(scope.row[col.prop])])
                      }, _toDisplayString(scope.row[col.prop] || '--'), 3))
                    : (col.type === 'button')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "link",
                          onClick: ($event: any) => (_ctx.goPath(scope.row))
                        }, "查看", 8, _hoisted_10))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(scope.row[col.prop] || '--'), 1))
              ]),
              _: 2
            }, 1032, ["label", "width", "minWidth", "show-overflow-tooltip"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data"]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_pagination, {
          layout: "total, sizes, prev, pager, next, jumper",
          "page-sizes": [10, 15, 20, 25, 30],
          total: _ctx.pagination.total,
          "page-size": _ctx.pagination.pageSize,
          "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination.pageSize) = $event)),
          currentPage: _ctx.pagination.pageNum,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pagination.pageNum) = $event)),
          onCurrentChange: _ctx.handlePageChange,
          onSizeChange: _ctx.handleSizeChange
        }, null, 8, ["total", "page-size", "currentPage", "onCurrentChange", "onSizeChange"])
      ])
    ])
  ]))
}